import { ErrorHandler, Injectable, inject } from '@angular/core';
import { LoggingService } from './logging.service';

@Injectable()
export class ErrorHandlerService extends ErrorHandler {
  private readonly loggingService = inject(LoggingService);
  /**
   *
   * @param error
   */
  override handleError(error: Error) {
    console.error(error); // Log to console (for debugging
    this.loggingService.logException(error); // Manually log exception
  }
}
